import { render, staticRenderFns } from "./tiket.vue?vue&type=template&id=53558a96&scoped=true&"
import script from "./tiket.vue?vue&type=script&lang=js&"
export * from "./tiket.vue?vue&type=script&lang=js&"
import style0 from "./tiket.vue?vue&type=style&index=0&id=53558a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53558a96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53558a96')) {
      api.createRecord('53558a96', component.options)
    } else {
      api.reload('53558a96', component.options)
    }
    module.hot.accept("./tiket.vue?vue&type=template&id=53558a96&scoped=true&", function () {
      api.rerender('53558a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/tiket.vue"
export default component.exports